export enum SortingState {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
}
